import type { CampaignData } from './types';
import { supabase } from './supabase';

// Mock database using localStorage
const STORAGE_KEY = 'campaign_data';
const SUPABASE_STORAGE_KEY = 'campaign_entries';

export const saveCampaignData = async (data: any, localData: CampaignData) => {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();

    if (error) {
      console.error('Error fetching session:', error);
      return;
    }
    
    if (!session || !session.user) {
      console.error('User is not authenticated');
      return;
    }

    const user = session.user;
    const submissionId = crypto.randomUUID();
    // Format data for storage
    const campaignPayload = {
      id: submissionId,
      user_id: user?.id,
      ...data,
    };

     // Format data for storage
    const campaignPayloadLocal = {
      id: submissionId,
      ...localData,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString()
    };

    // Save to localStorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(campaignPayloadLocal));

    console.log(`✅ Campaign data saved successfully [${submissionId}]:`, campaignPayload);
     const { data:compaignSavedData, error:compaignError } = await supabase.from(SUPABASE_STORAGE_KEY).insert([campaignPayload]);
    return campaignPayloadLocal;
  } catch (error) {
    console.error('❌ Error saving campaign data:', error);
    throw error;
  }
};

// Test database connection (always returns true since we're using localStorage)
export const testDatabaseConnection = async () => {
  return true;
};